import { HtmlData } from "@ts/data/HtmlData";
import { simpleForm } from "../core/SimpleForm";
import { Utils } from "../core/Utils";
import { AbstractSection } from "./AbstractSection";

export class Heading {
    text: string = '';
    level: number = 2;
}

export class HeadingSection extends AbstractSection {

    public constructor(section:HtmlData) {
        super(section);
        this.renderTarget.classList.add('heading-wrapper');
    }

    protected onViewRender(): void {
        const data = this.data as HtmlData;
        this.renderTarget.innerHTML = `<h2 id="heading-level"'>${data.htmlcode}</h2}>`;
    }

    protected onEditRender(): void {
        const data = this.data as HtmlData;
        this.renderTarget.innerHTML = Utils.minify(`
            <h2 id="heading-level"'>${data.htmlcode}</h2>`);
        const headingElement = this.renderTarget.querySelector('h2') as HTMLHeadingElement;
        
        if (this.tbar) {
            this.tbar.add('Rubriktext', 
                `Här anger du rubrikens text`,
                'text', async () => {
                await simpleForm('Ange ny rubriktext', 1, 'Text:', headingElement.innerText, 'Min rubrik')
                    .then((text: string) => {
                        headingElement.innerHTML = text;
                        Utils.forceRefresh(headingElement);
                    });
            });
        }
    }

    public parseContent(): void {
        const h = this.renderTarget.querySelector('h2') as HTMLHeadingElement;
        (this.data as HtmlData).htmlcode = h.innerHTML;
    }
}